import { from, of } from 'rxjs';
import { AuthHttp } from '@common/services';
import { openNotification } from '@common/helpers';
import { catchError } from 'rxjs/operators';

/**
 * GET /companies/summary
 *
 */
export function getCompaniesAPI(page, pageSize, sortBy, sortOrder) {
  const url = `companies/summary?page=${page}&limit=${pageSize}${sortBy ? '&sortBy=' + sortBy : ''}${sortOrder ? '&sortOrder=' + sortOrder : ''}`;
  return from(AuthHttp.get(url));
}

/**
 * GET /companies/:id
 *
 */
export function getCompanyDetailsAPI(id) {
  const url = `/companies/${id}`;
  return from(AuthHttp.get(url));
}

/**
 * PUT /companies/:id
 * 
 * @param id
 * @param details
 */
export function updateCompanyAPI(id, details) {
  const url = `/companies/${id}`;
  return from(AuthHttp.put(url, details));
}

/**
 * POST /companies
 *
 * @param companyObject
 */
export function createCompanyAPI(company) {
  const url = 'companies';
  return from(AuthHttp.post(url, company));
}

/**
 * DELETE /company
 * @param ids id of user of BU (Required)
 */
export function removeCompanies(ids) {
  const url = `/companies?companyIds=${ids}`;
  return from(AuthHttp.delete(url, {})).pipe(
    catchError(e => {
      const messages = e.response.data.messages;
      openNotification(
        'error',
        messages ? messages[0].message : 'Occurred error when remove companies from server!'
      );
      return of({});
    })
  );
}